import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    authenticated: false,
    user: null
  },

  getters: {
    authenticated (state) {
      return state.authenticated
    },

    user (state) {
      return state.user
    },
  },

  mutations: {
    SET_AUTHENTICATED (state, value) {
      state.authenticated = value
    },

    SET_USER (state, value) {
      state.user = value
    }
  },

  actions: {
    async signIn ({ dispatch }, credentials) {
      await Vue.axios.get('/sanctum/csrf-cookie')
      await Vue.axios.post('/login', credentials)
        .catch(error => {
          alert('Incorrect credentials, please try again!')
        });

      return dispatch('me')
    },

    async signOut ({ dispatch }) {
      await Vue.axios.post('/logout')

      return dispatch('me')
    },

    async register ({ dispatch }, credentials) {
      await Vue.axios.get('/sanctum/csrf-cookie')
      await Vue.axios.post('/register', credentials)

      return dispatch('me')
    },

    me ({ commit }) {
      return Vue.axios.get('/api/user').then((response) => {
        commit('SET_AUTHENTICATED', true)
        commit('SET_USER', response.data)
      }).catch(() => {
        commit('SET_AUTHENTICATED', false)
        commit('SET_USER', null)
      })
    }
  }
}
